// Material Dashboard 2 PRO React TS Base Styles
import colors from '@theme/base/colors';
import borders from '@theme/base/borders';
import boxShadows from '@theme/base/boxShadows';

// Material Dashboard 2 PRO React TS Helper Functions
import linearGradient from '@theme/functions/linearGradient';

const { white, gradients, grey, transparent, dark } = colors;
const { borderWidth } = borders;
const { md } = boxShadows;

// types
type Types = any;

const switchButton: Types = {
  defaultProps: {
    disableRipple: false
  },

  styleOverrides: {
    root: {
      width: '2.5rem',
      height: '1.25rem',
      padding: 0,
      margin: '0',
      transition: 'all 0.5s smooth',

      '& .MuiSwitch-colorInfo': {
        color: gradients.info.main,

        '&:hover': {
          backgroundColor: transparent.main
        },

        '&.Mui-checked': {
          color: gradients.info.main,

          '&:hover': {
            backgroundColor: transparent.main
          },

          '& .MuiSwitch-thumb': {
            borderColor: `${gradients.info.main} !important`
          },

          '& + .MuiSwitch-track': {
            backgroundColor: `${gradients.info.main} !important`,
            borderColor: `${gradients.info.main} !important`,
            opacity: 1
          }
        }
      },
      '& .MuiSwitch-colorDefault': {
        color: dark.main,

        '&:hover': {
          backgroundColor: transparent.main
        },

        '&.Mui-checked': {
          color: dark.main,

          '&:hover': {
            backgroundColor: transparent.main
          },

          '& .MuiSwitch-thumb': {
            borderColor: `${dark.main} !important`
          },

          '& + .MuiSwitch-track': {
            backgroundColor: `${dark.main} !important`,
            borderColor: `${dark.main} !important`,
            opacity: 1
          }
        }
      }
    },
    switchBase: {
      padding: 0,
      color: gradients.secondary.main,

      '&:hover': {
        backgroundColor: transparent.main
      },

      '&.Mui-checked': {
        color: gradients.secondary.main,

        '&:hover': {
          backgroundColor: transparent.main
        },

        '& .MuiSwitch-thumb': {
          borderColor: `${gradients.secondary.main} !important`
        },

        '& + .MuiSwitch-track': {
          backgroundColor: `${gradients.secondary.main}`,
          borderColor: `${gradients.secondary.main}`,
          opacity: 1
        }
      },

      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: '0.1 !important'
      },

      '&.Mui-focusVisible .MuiSwitch-thumb': {
        backgroundImage: linearGradient(
          gradients.info.main,
          gradients.info.state
        )
      }
    },

    thumb: {
      backgroundColor: white.main,
      boxShadow: md,
      width: '1rem',
      height: '1rem',
      margin: '2px'
    },

    track: {
      width: '100%',
      height: '100%',
      borderRadius: '2.5rem',
      backgroundColor: grey[600],
      border: `${borderWidth[1]} solid ${grey[600]}`,
      opacity: 1
    },

    checked: {}
  }
};

export default switchButton;
